<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina/mendoza')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/argentina/mendoza/achaval-ferrer')">Achaval Ferrer</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/bodega-aleanna')">Bodega Aleanna</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/bodega-alta-vista')">Bodega Alta Vista</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/bodega-catena-zapata')">Bodega Catena Zapata</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/bodega-luigi-bosca')">Bodega Luigi Bosca</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/familia-zuccardi')">Familia Zuccardi</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/michel-rolland')">Michel Rolland</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/rutini-wines')">Rutini Wines</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/trapiche')">Trapiche</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/mendoza/vina-cobos')">Vina Cobos</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Achaval Ferrer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Chissà come nascono i vini pregiati di culto? Alcuni diventano famosi attraverso generazioni di storia della vinificazione,
                        alcuni impiegano produttori di vino famosi per rafforzare il loro marchio. E alcuni, come Achaval Ferrer, ce l'hanno
                        vini argentini favolosamente splendidi che stanno da soli, a prescindere.
                    </div>

                    <div class="howto-title2">Tecnica europea con passione sudamericana</div>
                    <div class="howto-text">
                        Fondata nel 1998 da tre grandi successi, Santiago Achaval, Manuel Ferrer e l'enologo Roberto
                        Cipresso, Achaval Ferrer è un po' una storia di successo. Dopo essersi interessato al vino durante
                        Dopo i suoi studi a Stanford, Santiago decise presto che la contabilità non era il suo cuore.
                        Cominciavano ad emergere vini pregiati argentini, così insieme al suo amico (un avvocato che aveva
                        disamorati della legge), iniziarono a cercare opportunità nel loro paese natale
                        Argentina. Gli amici hanno unito le forze con l'enologo italiano Roberto Cipresso, chiedendo consiglio
                        dell'enologo francese Michel Rolland e l'eredità viticola dell'Argentina è stata assicurata.
                    </div>

                    <div class="howto-title2">Immediatamente favoloso</div>
                    <div class="howto-text">
                        I vigneti di Achaval Ferrer sono tre parcelle fittamente piantate di Malbec ad altitudini vertiginose:
                        Finca Altamira si trova a 1.050 metri, Finca Mirador a 700 metri e Finca Bella Vista a 980 metri.
                        Queste variazioni di altitudine, terroir, clima e irrigazione sono uniche per ogni appezzamento e possono
                        creare varietà straordinarie anche all'interno dello stesso campo. Nonostante sia un nuovo ragazzo nel quartiere,
                        Il successo di Achaval Ferrer è stato immediato, con 91 punti nelle degustazioni alla cieca. Questo ha attirato l'attenzione di due
                        personaggi molto influenti: il primo è stato Robert Parker, il cui sostegno e gli alti ascolti (the
                        più alto per qualsiasi buon vino argentino) ha sostanzialmente aperto la strada all'esportazione negli Stati Uniti del
                        Achaval Ferrer. Galvanizzata da questo successo negli Stati Uniti, la tenuta è stata acquistata nel 2011 dal
                        SPI Group – un leader globale nel settore del vino e dei liquori che include la vodka Stolichnaya (Stoli) sotto la sua
                        ombrello.
                    </div>

                    <div class="howto-title2">3 vini nella top 10 dell'Argentina</div>
                    <div class="howto-text">
                        Tre dei vini di Achaval Ferrer occupano il settimo posto e si uniscono all'ottavo posto nella lista di wine-searcher.com
                        dei vini argentini più costosi (Finca Altamira, Finca Mirador e Finca Bella Vista a € 100
                        e 90 € rispettivamente). Nonostante sia il vino con il punteggio più alto in Argentina, nonché uno dei
                        più ricercato, Achaval Ferrer sta perdendo interesse in un mercato volubile. La qualità invece no
                        sofferto (au contraire), quindi gli investitori esperti potrebbero essere saggi per accaparrarsi alcune annate scelte e
                        fare un gioco d'attesa.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Achaval Ferrer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wer weiß, wie erlesene Kultweine entstehen? Einige erlangten durch Generationen von Weinbaugeschichte Berühmtheit,
                        Einige beschäftigen Starwinzer, um ihre Marke zu stärken. Und einige, wie Achaval Ferrer, haben es getan
                        sagenhaft schöne argentinische Weine, die auf jeden Fall für sich stehen.
                    </div>

                    <div class="howto-title2">Europäische Technik mit südamerikanischer Leidenschaft</div>
                    <div class="howto-text">
                        1998 von den drei Leistungsträgern Santiago Achaval, Manuel Ferrer und dem Winzer Roberto gegründet
                        Cipresso, Achaval Ferrer ist eine Art Erfolgsgeschichte. Nachdem er sich währenddessen für Wein interessierte
                        Während seines Studiums in Stanford kam Santiago bald zu dem Schluss, dass Buchhaltung nicht seine Leidenschaft war.
                        Es begannen erlesene argentinische Weine aufzutauchen, also zusammen mit seinem Freund (einem Anwalt, der …
                        Nachdem sie die Liebe zum Gesetz verloren hatten, begannen sie, in ihrer Heimat nach Möglichkeiten zu suchen
                        Argentinien. Die Freunde schlossen sich mit dem italienischen Winzer Roberto Cipresso zusammen und suchten Rat
                        des französischen Önologen Michel Rolland und das weinbauliche Erbe Argentiniens wurde gesichert.
                    </div>

                    <div class="howto-title2">Sofort fabelhaft</div>
                    <div class="howto-text">
                        Die Weinberge von Achaval Ferrer bestehen aus drei dicht bepflanzten Malbec-Parzellen in schwindelerregender Höhe:
                        Die Finca Altamira liegt auf 1.050 Metern, die Finca Mirador auf 700 Metern und die Finca Bella Vista auf 980 Metern.
                        Diese Unterschiede in der Höhenlage, dem Terroir, dem Klima und der Bewässerung sind für jede Parzelle und Dose einzigartig
                        schaffen außergewöhnliche Vielfalt auch innerhalb desselben Bereichs. Obwohl ich ein Neuling auf dem Block bin,
                        Der Erfolg von Achaval Ferrer stellte sich sofort ein und er erreichte bei Blindverkostungen 91 Punkte. Das erregte die Aufmerksamkeit von zwei
                        sehr einflussreiche Leute: Der erste war Robert Parker, dessen Unterstützung und hohe Einschaltquoten (der
                        höchste aller argentinischen Spitzenweine) ebnete im Grunde den Weg für den Export in die USA
                        Achaval Ferrer. Beflügelt durch diesen Erfolg in den USA wurde das Anwesen 2011 von der USA gekauft
                        SPI Group – ein weltweit führender Anbieter von Wein und Spirituosen, zu dem auch Stolichnaya (Stoli) Wodka gehört
                        Regenschirm.
                    </div>

                    <div class="howto-title2">3 Weine in den Top 10 Argentiniens</div>
                    <div class="howto-text">
                        Drei Weine von Achaval Ferrer belegen den siebten und den achten Platz auf der Liste von wine-searcher.com
                        der teuersten argentinischen Weine (Finca Altamira, Finca Mirador und Finca Bella Vista für 100 €).
                        bzw. 90 €). Obwohl er der am höchsten bewertete Wein in Argentinien und einer der besten ist
                        Achaval Ferrer ist der gefragteste Anbieter und verliert das Interesse an einem unbeständigen Markt. Qualität jedoch nicht
                        gelitten (im Gegenteil), daher wäre es für kluge Anleger ratsam, einige ausgewählte Jahrgänge zu ergattern
                        ein Wartespiel spielen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Achaval Ferrer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Qui sait comment sont nés les vins fins cultes ? Certains sont devenus célèbres grâce à des générations d'histoire viticole,
                        certains emploient des vignerons vedettes pour booster leur marque. Et certains, comme Achaval Ferrer ont
                        des vins argentins fabuleusement magnifiques qui se tiennent seuls, peu importe.
                    </div>

                    <div class="howto-title2">Technique européenne avec passion sud-américaine</div>
                    <div class="howto-text">
                        Fondée en 1998 par trois grands talents, Santiago Achaval, Manuel Ferrer et le vigneron Roberto
                        Cipresso, Achaval Ferrer est un peu une success story. Après s'être intéressé au vin pendant
                        ses études à Stanford, Santiago ont rapidement décidé que la comptabilité n'était pas là où son cœur reposait.
                        Les vins fins argentins commençaient à émerger, alors avec son ami (un avocat qui avait
                        tombés amoureux de la loi), ils ont commencé à chercher des opportunités dans leur
                        Argentine. Les amis se sont associés au vigneron italien Roberto Cipresso, ont demandé conseil
                        de l'œnologue français Michel Rolland et l'héritage viticole de l'Argentine a été sécurisé.
                    </div>

                    <div class="howto-title2">Instantanément fabuleux</div>
                    <div class="howto-text">
                        Les vignobles d'Achaval Ferrer sont trois parcelles de Malbec densément plantées à des altitudes vertigineuses :
                        La Finca Altamira est à 1 050 mètres, la Finca Mirador à 700 mètres et la Finca Bella Vista à 980 mètres.
                        Ces variations d'altitude, de terroir, de climat et d'irrigation sont propres à chaque parcelle et peuvent
                        créer une variété extraordinaire même au sein d'un même domaine. En dépit d'être un nouvel enfant sur le bloc,
                        Le succès d'Achaval Ferrer est immédiat avec 91 points en dégustation à l'aveugle. Cela a attiré l'attention de deux
                        des gens très influents : le premier était Robert Parker, dont le soutien et la cote d'écoute (le
                        le plus élevé de tous les vins fins argentins) a essentiellement ouvert la voie à l'exportation vers les États-Unis du
                        Acaval Ferrer. Galvanisé par ce succès aux USA, le domaine est racheté en 2011 par le
                        SPI Group - un leader mondial des vins et spiritueux qui comprend la vodka Stolichnaya (Stoli) sous son
                        parapluie.
                    </div>

                    <div class="howto-title2">3 vins dans le top 10 argentin</div>
                    <div class="howto-text">
                        Trois des vins d'Achaval Ferrer occupent la septième place et rejoignent la huitième place sur la liste de wine-searcher.com
                        des vins argentins les plus chers (Finca Altamira, Finca Mirador et Finca Bella Vista à 100 €
                        et 90 € respectivement). Bien qu'il soit le vin le mieux noté d'Argentine, ainsi que l'un des
                        le plus recherché, Achaval Ferrer se désintéresse d'un marché instable. La qualité n'a cependant pas
                        souffert (au contraire), donc les investisseurs avertis pourraient être avisés de se procurer des millésimes de choix et
                        jouer à un jeu d'attente.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Achaval Ferrer</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Who knows how cult fine wines are born? Some come to fame via generations of winemaking history,
                        some employ star winemakers to boost their brand. And some, such as Achaval Ferrer have
                        fabulously gorgeous Argentinian wines that stand alone, regardless.
                    </div>

                    <div class="howto-title2">European technique with South American passion</div>
                    <div class="howto-text">
                        Founded in 1998 by three high achievers, Santiago Achaval, Manuel Ferrer and winemaker Roberto
                        Cipresso, Achaval Ferrer is a bit of a success story. After becoming interested in wine during
                        his studies at Stanford, Santiago soon decided that accountancy was not where his heart lay.
                        Argentinian fine wines were beginning to emerge, so along with his friend (an lawyer who had
                        fallen out of love with the law), they began to look for opportunities in their native
                        Argentina. The friends joined forces with Italian winemaker Roberto Cipresso, sought the advice
                        of French oenologist Michel Rolland and Argentina’s viticultural legacy was secured.
                    </div>

                    <div class="howto-title2">Instantly fabulous</div>
                    <div class="howto-text">
                        Achaval Ferrer’s vineyards are three, densely planted parcels of Malbec at dizzying altitudes:
                        Finca Altamira is at 1,050 metres, Finca Mirador at 700 metres and Finca Bella Vista 980 metres.
                        These variations in elevation, terroir, climate and irrigation are unique to each parcel and can
                        create extraordinary variety even within the same field. Despite being a new kid on the block,
                        Achaval Ferrer’s success was immediate, scoring 91 in blind tastings. This caught the eye of two
                        very influential people: the first was Robert Parker, whose support and high ratings (the
                        highest for any Argentinan fine wine) basically paved the way for export to the US of the
                        Achaval Ferrer. Galvanised by this success stateside, the estate was purchased in 2011 by the
                        SPI Group – a global leader in wine and spirits that include Stolichnaya (Stoli) vodka under its
                        umbrella.
                    </div>

                    <div class="howto-title2">3 wines on Argentina’s top 10</div>
                    <div class="howto-text">
                        Three of Achaval Ferrer’s wines hold seventh and join eighth place on wine-searcher.com’s list
                        of most expensive Argentinian wines (Finca Altamira, Finca Mirador and Finca Bella Vista at €100
                        and €90 respectively). Despite being the highest rated wine in Argentina, as well as one of the
                        most sought after, Achaval Ferrer is losing interest in a fickle market. Quality however has not
                        suffered (au contraire), so savvy investors might be wise to snap up some choice vintages and
                        play a waiting game.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AchavalFerrer",
        head: {
            title: 'Achaval Ferrer | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Experience the pinnacle of Argentine wine-making with Achaval Ferrer. A leader in the Mendoza wine region, their expertly crafted Malbec, Cabernet Sauvignon, and blends showcase the best of Argentine terroir. Savor the essence of excellence in every glass.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        },
        data () {
            return {
                select: { report: 'Achaval Ferrer', src: '/wine-guide/argentina/mendoza/achaval-ferrer' },
                items: [
                    { report: 'Achaval Ferrer', src: '/wine-guide/argentina/mendoza/achaval-ferrer' },
                    { report: 'Bodega Aleanna', src: '/wine-guide/argentina/mendoza/bodega-aleanna' },
                    { report: 'Bodega Alta Vista', src: '/wine-guide/argentina/mendoza/bodega-alta-vista' },
                    { report: 'Bodega Catena Zapata', src: '/wine-guide/argentina/mendoza/bodega-catena-zapata' },
                    { report: 'Bodega Luigi Bosca', src: '/wine-guide/argentina/mendoza/bodega-luigi-bosca' },
                    { report: 'Familia Zuccardi', src: '/wine-guide/argentina/mendoza/familia-zuccardi' },
                    { report: 'Michel Rolland', src: '/wine-guide/argentina/mendoza/michel-rolland' },
                    { report: 'Rutini Wines', src: '/wine-guide/argentina/mendoza/rutini-wines' },
                    { report: 'Trapiche', src: '/wine-guide/argentina/mendoza/trapiche' },
                    { report: 'Vina Cobos', src: '/wine-guide/argentina/mendoza/vina-cobos' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover,
    .wine-guide-country.active {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
